import React, { useEffect, useState } from 'react'
import { Modal, Tooltip } from 'antd'
import * as ui from '@digital/ui'
import { Visibility } from '@app/components';


interface IButtonModalGenericProps {
    buttonText: string;
    buttonIcon?: string;
    modalTitle: string;
    children: React.ReactNode;
    actions?: React.ReactNode[];
    hasCloseButton?: boolean;
    reload?: boolean;
    tooltip?: string;
}

export const ButtonModalGeneric = ({
    buttonText,
    buttonIcon,
    modalTitle,
    children,
    actions,
    hasCloseButton = true,
    reload,
    tooltip
}: IButtonModalGenericProps) => {

    const [open, setOpen] = useState(false);
    const [actionsModal, setActionsModal] = useState<React.ReactNode[]>([]);

    const onModalOpen = () => {
        setOpen(!open);
    }

    useEffect(() => {
        let tempActions: React.ReactNode[] = [];

        if (hasCloseButton) {
            tempActions.push(
                <ui.Button
                    title='Fechar'
                    onClick={() => {
                        setOpen(false);
                    }}
                    type="link"
                />,
            );
        }

        setActionsModal([...tempActions, ...actions || []]);
    }, [actions]);

    useEffect(() => {
        if (open) {
            onModalOpen();
        }
    }, [reload]);

    return (<>
        <Tooltip title={tooltip}>
            <ui.Button
                icon={buttonIcon}
                onClick={onModalOpen}>
                {buttonText}
            </ui.Button>
        </Tooltip>

        <Visibility
            visible={open}
        >
            <Modal
                title={modalTitle || 'ButtonModalGeneric'}
                visible={open}
                onCancel={onModalOpen}
                footer={actionsModal || null}
            >
                {children}
            </Modal>
        </Visibility>

    </>);

}